<template>
  <a-modal
    title="外雇工人信息"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="id" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input :disabled="showable" v-decorator="['id']" />
        </a-form-item>
        <a-form-item
          label="队伍名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['teamName', {rules: [{required: true, message: '请输入队伍名称'}]}]" />
        </a-form-item>
        <a-form-item
          label="费用内容及完成工作情况"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['content', {rules: [{required: true, message: '请输入费用内容及完成工作情况'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="费用金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['totalPrice', {rules: [{required: true, message: '请输入费用(精确到两位小数)'}]}]" />
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['remark']"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <div>
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
export default {
  name: 'DailyHireWorkAdd',
  components: {},
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      theKey: 0,
      showable: false
    }
  },
  methods: {
    // 获取用户消息
    edit (child, type) {
      this.visible = true
      if (type === 'edit') {
        this.type = type
        this.theKey = child.key
      }
      if (type && type === 'add') {
        this.type = type
      }
      const {
        form: { setFieldsValue, resetFields }
      } = this
      if (type === 'add') {
        resetFields()
      } else if (type === 'edit') {
        const pickFiled = [
          'id',
          'teamName',
          'content',
          'totalPrice',
          'remark'
        ]
        this.$nextTick(() => {
          setFieldsValue(pick(child, pickFiled))
        })
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 结束保存用户信息
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.type === 'add') {
            this.$emit('changeData', values)
          } else if (this.type === 'edit') {
            values.key = this.theKey
            this.$emit('editData', values)
          }
          this.visible = false
        }
      })
    },
    handleCancel () {
      this.visible = false
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    }
  },
  watch: {
  }
}
</script>

<style scoped>

</style>
